export default "__VITE_ASSET__316052cb__"